import Model from '@/models/Model.js';

/** The server accepts at most this many ids per mark-as-read request (ReadReceiptRequest). */
export const MARK_AS_READ_BATCH_SIZE = 100;

export default class ReadReceipt extends Model {
    static entity = 'read_receipts';

    static modelName = 'ReadReceipt';

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            readable_id: this.attr(null),
            readable_type: this.attr(null),
            readable_type_entity: this.attr(null),

            ...super.fields(),

            user: this.belongsTo('users', 'user_id'),
            readable: this.morphMany('read_receipts', 'readable_id', 'readable_type_entity'),
        };
    }

    /**
     * Mark every given record of one type as read, in batches the server accepts, and store the receipts.
     *
     * @param {string} readableType
     * @param {Array<number>} readableIds
     */
    static async markAllAsRead(readableType, readableIds) {
        for (let start = 0; start < readableIds.length; start += MARK_AS_READ_BATCH_SIZE) {
            const { response } = await this.api().put('/api/mark-as-read', {
                readable_ids: readableIds.slice(start, start + MARK_AS_READ_BATCH_SIZE),
                readable_type: readableType,
            });

            await this.insert({ data: response.data.data });
        }
    }
}
